module.exports = __webpack_public_path__ + "assets/2df62c2aba340f07b5eb082f6f0b0eb0.png";